module.exports = __webpack_public_path__ + "static/media/parking-black.624f7f0f.svg";